module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-tab"
  }, [_c('ul', {
    staticClass: "supplierList"
  }, _vm._l((_vm.supplierArr), function(item) {
    return _c('li', [_c('div', {
      staticClass: "listLeft"
    }, [_c('h3', {
      on: {
        "click": function($event) {
          _vm.openDetail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('h5', [_c('span', [_vm._v("联系人：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.contactName || '--'))])]), _vm._v(" "), _c('h5', [_c('span', [_vm._v("联系方式：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getPhone(item.phone)))])]), _vm._v(" "), _c('h5', [_c('span', [_vm._v("联系地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.address || '--'))])]), _vm._v(" "), _c('h5', [_c('span', [_vm._v("负责人：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.managerName || '--'))])])]), _vm._v(" "), _c('div', {
      staticClass: "listRight"
    }, [_c('em', {
      staticClass: "BottomRound"
    }), _vm._v(" "), _c('em', {
      staticClass: "TopRound"
    }), _vm._v(" "), _vm._l((item.rates), function(it) {
      return _c('h6', [_c('span', [_vm._v(_vm._s(it.attrName) + "：")]), _vm._v(" "), _c('el-rate', {
        attrs: {
          "value": _vm._f("toNumber")(it.value4Show),
          "colors": _vm._f("toColor")(it.value4Show),
          "disabled": ""
        }
      }), _vm._v(" "), (it.value4Show < 3) ? _c('span', {
        staticClass: "tag low"
      }, [_vm._v("低")]) : (it.value4Show > 4) ? _c('span', {
        staticClass: "tag high"
      }, [_vm._v("高")]) : _c('span', {
        staticClass: "tag mid"
      }, [_vm._v("中")])], 1)
    })], 2)])
  })), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper clearfix"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "page-sizes": [10, 20, 30, 40],
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e692936e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/product/supplier-tab.vue
// module id = 1348
// module chunks = 82